export const MAX_VALUES = {
  1: 30,
  2: 10,
  3: 5,
  4: 5,
  5: 5,
  6: 5,
  7: 5,
  8: 5,
  9: 20,
  10: 20,
  11: 15,
  12: 15,
  13: 10,
  14: 10,
  15: 30,
};
